<template>
  <div>
    <a :href="url" target="_blank">
      <v-img width="150" height="150" :src="image" />
    </a>
    <p class="mb-0">{{ from }}</p>
    <p class="mb-0">{{ to }}</p>
  </div>
</template>

<script>
export default {
  name: "CertificationComponent",
  props: {
    url: String,
    image: String,
    from: String,
    to: String
  }
};
</script>

<style>
</style>